import { createContext, type Context } from 'react';
import noop from 'lodash/noop';
import type { IssueId } from '../../../../../../model/issue';
import type { CustomMarshal } from '../types';

type RoadmapStyleMarshalProps = {
	customStyleMarshal: CustomMarshal;
	onRowMouseEnter: (id: IssueId) => void;
	onRowMouseLeave: (id: IssueId) => void;
	onRowSelect: (id: IssueId) => void;
	onRowDeselect: (id: IssueId) => void;
};

const RoadmapStyleMarshalContext: Context<RoadmapStyleMarshalProps> = createContext({
	onRowMouseEnter: noop,
	onRowMouseLeave: noop,
	onRowSelect: noop,
	onRowDeselect: noop,
	customStyleMarshal: {},
});

const { Provider, Consumer } = RoadmapStyleMarshalContext;

export default RoadmapStyleMarshalContext;
export { Provider, Consumer };
export type { RoadmapStyleMarshalProps };
